import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Users, UserPlus } from 'lucide-react';
import { getRoleBadgeStyle, getRoleLabel } from './constants';

const ShopUsersSection = ({ users, canEdit, onAddUser }) => {
  return (
    <AccordionItem value="users" className="bg-[#1E293B] border border-[#334155] rounded-lg overflow-hidden">
      <AccordionTrigger className="px-6 py-4 hover:no-underline hover:bg-[#334155]/30" data-testid="shop-users-trigger">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-[#8B5CF6]/20 flex items-center justify-center">
            <Users className="w-5 h-5 text-[#A78BFA]" />
          </div>
          <span className="text-lg font-semibold text-[#E2E8F0]" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Shop Users
          </span>
          <Badge variant="outline" className="ml-2 bg-[#334155] text-[#94A3B8] border-[#475569]">
            {users?.length || 0}
          </Badge>
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-6 pb-4">
        {canEdit && (
          <div className="flex justify-end mb-4">
            <Button
              size="sm"
              onClick={onAddUser}
              className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white"
              data-testid="add-user-button"
            >
              <UserPlus className="w-4 h-4 mr-1" />
              Add User
            </Button>
          </div>
        )}
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="border-b border-[#334155] hover:bg-transparent">
                <TableHead className="text-[#94A3B8] font-semibold text-xs uppercase tracking-wider">Name</TableHead>
                <TableHead className="text-[#94A3B8] font-semibold text-xs uppercase tracking-wider">Email</TableHead>
                <TableHead className="text-[#94A3B8] font-semibold text-xs uppercase tracking-wider">Phone</TableHead>
                <TableHead className="text-[#94A3B8] font-semibold text-xs uppercase tracking-wider">Role</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {users?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} className="text-center py-8 text-[#64748B]">
                    No non-admin users found.
                  </TableCell>
                </TableRow>
              ) : (
                users?.map((user) => (
                  <TableRow key={user._id} className="border-b border-[#334155]/50 hover:bg-[#334155]/20">
                    <TableCell className="text-[#E2E8F0] font-medium">
                      {user.fullname || `${user.firstname || ''} ${user.lastname || ''}`.trim() || 'N/A'}
                    </TableCell>
                    <TableCell className="text-[#94A3B8]">{user.email}</TableCell>
                    <TableCell className="text-[#94A3B8]">{user.phoneno || user.phoneNumber || 'N/A'}</TableCell>
                    <TableCell>
                      <Badge variant="outline" className={`${getRoleBadgeStyle(user.role)} border`}>
                        {getRoleLabel(user.role)}
                      </Badge>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};

export default ShopUsersSection;
